import { type DependencyList, useEffect, useRef } from 'react';

function useUnmountEffect(callback: () => void, deps: DependencyList = []) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => () => callbackRef.current(), [...deps]);
}

export default useUnmountEffect;
